const openQuickShopModal = (product) => {
  // The "product" parameter contains values from the tolstoy spotlight carousel that you can use as a handle into which values to render on the modal.
  //You can check the values by logging it.
  console.log("TOLSTOY CTA CLICK", product);

  const productHandle = product.handle
  if (productHandle) {
    document.dispatchEvent(
      new CustomEvent('quickShop:open', {
        detail: {
          productHandle: productHandle
        }
      })
    )
  }
}

const subscribeToTolstoyProductCardClick = () => {
  const myCallback = (payload) => {
    const productHandle = payload.productHandle
    if (productHandle) {
      document.dispatchEvent(
        new CustomEvent('quickShop:open', {
          detail: {
            productHandle: productHandle
          }
        })
      )
    }
    window.tolstoyWidget.closePlayer();
  };

  const options = {};

  window.tolstoyWidget.subscribe(
    "tolstoy_product_card_click",
    myCallback,
    options
  );
};

if (window.tolstoyWidget) {
  subscribeToTolstoyProductCardClick();
} else {
  window.addEventListener("tolstoyWidgetReady", () => {
    subscribeToTolstoyProductCardClick();
  });
}

//This Function is for the onClick Function on Tolstoy Spotlight Carousel "+" button
const subscribeToQuickShopClick =() =>  {
  window.tolstoyWidget.subscribe(
    "tolstoy_spotlight_carousel_quick_shop_click",
     (o) => {o.product && o.product.handle? openQuickShopModal(o.product): console.error("Product handle is not available in the event");},
    { disableDefault: !0 },
  );
}

window.tolstoyWidget ? subscribeToQuickShopClick(): window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick);
